<template>
	<div></div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	layout: 'app',
	middleware: 'auth',

	computed: {
		...mapGetters({
			user: 'auth/user'
		})
	},

	metaInfo() {
		return { title: this.user ? this.user.name : '' }
	}
}
</script>

<style scoped></style>
